// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-KoF","colMin":"styles_colMin__31CyC"};